import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import {Modal, ModalBody, ModalFooter, ModalHeader} from "../Modal";
import CustomButton from "../CustomButton";
import RadioButton from "../RadioButton";
import Api from "../../services/Api";
import { getLanguage } from "../../lang/helpers";
import successIcon from "url:shared-assets/icons/green/badge-check-filled.svg";

interface Props {
  setShowSurveyType: Function;
}

const UsabilitySurvey = (props: Props) => {
  const api = Api.getInstance();
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answer, setAnswer] = useState(0);
  const [dataIsSent, setDataIsSent] = useState<boolean>(false);

  const goToNextStep = () => {
    if (currentIndex < 3) {
      setTimeout(() => {
        setCurrentIndex(currentIndex + 1);
      }, 500);
    }
  };

  const sendData = () => {
    if (dataIsSent) {
      return;
    }
    const data = {
      answer: answer
    }
    try {
      api.post("client/usability_survey", data).then((response) => {
        setDataIsSent(true);
      });
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  const renderStep1 = () => {
    const text1 =
      lang === "sv"
        ? "Hur enkel tycker du att plattformen är att använda?"
        : "How easy do you find the platform to use?";

    const answers = [
      {
        answer: 5,
        text: lang === "sv" ? "Mycket enkel" : "Very easy"
      },
      {
        answer: 4,
        text: lang === "sv" ? "Ganska enkel" : "Quite easy"
      },
      {
        answer: 3,
        text: lang === "sv" ? "Varken enkel eller svårt" : "Neither easy nor difficult"
      },
      {
        answer: 2,
        text: lang === "sv" ? "Ganska svår" : "Quite difficult"
      },
      {
        answer: 1,
        text: lang === "sv" ? "Mycket svår" : "Very difficult"
      },
    ]
    return (
      <div className="text-left">
        <p className="text-gray-300">{text1}</p>

        {
          answers.map(a => (
            <div className="flex mt-3 cursor-pointer" key={"answer_" + a.answer}>
              <RadioButton
                id={"a_" + a.answer}
                name={"a_" + a.answer}
                label={a.text}
                value={"" + a.answer}
                checked={a.answer === answer}
                onChange={() => setAnswer(a.answer)}
              />
            </div>
          ))
        }


      </div>
    );
  };

  const renderStep2 = () => {
    const text1 =
      i18n.language === "sv"
        ? "Din feedback hjälper oss att bli bättre!"
        : "Your feedback helps us improve!";
    return (
      <div className="flex flex-col gap-3 text-left h-full">
        <img
          src={successIcon}
          alt="Success"
          className="w-12 h-12 mb-4 text-center mx-auto"
        />
        <p className="text-gray-300 text-left">{text1}</p>
      </div>
    );
  };

  const showContent = () => {
    if (currentIndex === 1) {
      return renderStep2();
    } else {
      return renderStep1();
    }
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={() => {
          sendData();
          props.setShowSurveyType(null);
        }}
        ignoreOutsideClick={true}
      >
        <ModalHeader
          onClose={() => {
            sendData();
            props.setShowSurveyType(null);
          }}
        >
          <div className="z-title1">
            {currentIndex === 1
              ? lang === "sv"
                ? "Tack för ditt svar"
                : "Thanks for your response"
              : lang === "sv" ? "Vi värdesätter din feedback" : "We'd love your feedback"
            }
          </div>
        </ModalHeader>
        <ModalBody>{showContent()}</ModalBody>
        <ModalFooter>
          {currentIndex === 0 && (
            <div className="flex flex-col justify-between w-full gap-2">
              <CustomButton
                onClick={() => {
                  sendData();
                  goToNextStep();
                }}
              >
                {t("submit-feedback")}
              </CustomButton>
            </div>
          )}
          {currentIndex === 1 && (
            <CustomButton onClick={() => props.setShowSurveyType(null)}>
              {t("keep-growing")}
            </CustomButton>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default UsabilitySurvey;
